<script>
	import { createEventDispatcher, onMount } from 'svelte';
	import { replace, querystring } from 'svelte-spa-router';
	import { 
		TipoEvento,
		limparCacheTotal } from '../../utils';
	
	const dispatch = createEventDispatcher();
	
	onMount(async () => {
		let parametrosURL = new URLSearchParams($querystring);
		let mensagemQS = decodeURIComponent(escape(window.atob(parametrosURL.get('m'))));

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: mensagemQS,
		});

		limparCacheTotal();
		setTimeout( () => replace('#/'), 2000);
	});
</script>
